The identifier for the `CandidateProfile` that the `CandidateProcessHistoryItem` relates to.
